const env = require('/opt/build/repo/twing/environment.js');
let templatesModule = (() => {
let module = {
    exports: undefined
};

module.exports = (TwingTemplate) => {
    return new Map([
        [0, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = false;

                this.blocks = new Map([
                ]);
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(this.include(context, this.source, this.loadTemplate(`da7831e538363cdb2336892aa67270b98598f2aa9d60f85ae67d2ce428118a5f`, `da7831e538363cdb2336892aa67270b98598f2aa9d60f85ae67d2ce428118a5f`, 1, 135), new Map([[`class`, `o-container--pad`]]), false, false, 1));
            }

            getTemplateName() {
                return `da7831e538363cdb2336892aa67270b98598f2aa9d60f85ae67d2ce428118a5f`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `da7831e538363cdb2336892aa67270b98598f2aa9d60f85ae67d2ce428118a5f`, ``);
            }
        }],
        [135, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/objects/container/container.twig`, `da7831e538363cdb2336892aa67270b98598f2aa9d60f85ae67d2ce428118a5f`, 1);

                this.blocks = new Map([
                    ['content', [this, 'block_content']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/objects/container/container.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`    <p>This is default text.</p>
    <p class="u-text-center">This is text that has the utility class applied.</p>
  `);
            }

            getTemplateName() {
                return `da7831e538363cdb2336892aa67270b98598f2aa9d60f85ae67d2ce428118a5f`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `da7831e538363cdb2336892aa67270b98598f2aa9d60f85ae67d2ce428118a5f`, ``);
            }
        }],
    ]);
};

    return module.exports;
})();

env.registerTemplatesModule(templatesModule, 'da7831e538363cdb2336892aa67270b98598f2aa9d60f85ae67d2ce428118a5f');

let template = env.loadTemplate('da7831e538363cdb2336892aa67270b98598f2aa9d60f85ae67d2ce428118a5f');

module.exports = (context = {}) => {
    const rendered = template.render(context);
     const inputs = window.__twig_inputs__ || (window.__twig_inputs__ = new Map());
     inputs.set(
       rendered,
       { path: "@cloudfour/utilities/text/demo/text-align.twig", args: context }
     );
     return rendered;;
};